import type { CardColumn } from '@/components/CardTable';
import type { JournalEntryRow } from './columns';

export const filterColumns = (
  columns: CardColumn<JournalEntryRow>[],
  listColumns: string[]
) => {
  return columns.filter(
    (column) => column?.key && listColumns.includes(String(column.key))
  );
};
